import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpVerbsEnum } from '../shared/enums/http-verbs.enum';
import { NeptuneApi } from '../genericApi/neptune.api';
import { CreateSharedReportApiModel, SharedReportApiModel, SharedReportListItemApiModel, UpdateSharedReportApiModel } from './model/shared-report-api.model';
import { SharedReportSearchRequestApiModel } from './model/shared-report-search-request.model';
import { SharedReportSearchResponseApiModel } from './model/shared-report-search-response-api.model';
import { SendSharedReportApiModel } from './model/send-shared-report-api.model';

// TODO update this file when the backend for shared report is ready
@Injectable()
export class SharedReportApi {

    constructor(
        private neptuneApi: NeptuneApi
    ) {
    }

    /**
     * Gets a list of limited shared report information
     */
    public getList(): Observable<SharedReportListItemApiModel[]> {
        return this.neptuneApi.api<SharedReportListItemApiModel[]>(
            '/shared-reports',
            null,
            HttpVerbsEnum.GET,
            {},
            null,
            null,
            'v2'
        );
    }

    /**
     * Gets a list of limited shared report information
     */
    public search(query: SharedReportSearchRequestApiModel): Observable<SharedReportSearchResponseApiModel> {
        return this.neptuneApi.api<SharedReportSearchResponseApiModel>(
            '/shared-reports/search',
            query,
            HttpVerbsEnum.GET,
            {},
            null,
            null,
            'v2'
        );
    }

    /**
     * Gets the full details for a specific ID
     */
    public get(id: number): Observable<SharedReportApiModel> {
        return this.neptuneApi.api<SharedReportApiModel>(
            `/shared-reports/${id}`,
            null,
            HttpVerbsEnum.GET,
            {},
            null,
            null,
            'v2'
        );
    }

    /**
     * Updates and existing shared report
     */
    public update(sharedReport: UpdateSharedReportApiModel): Observable<number> {
        return this.neptuneApi.api<number>(
            `/shared-reports/${sharedReport.id}`,
            sharedReport,
            HttpVerbsEnum.PUT,
            {},
            null,
            null,
            'v2'
        );
    }

    /**
     * Creates a new shared report
     */
    public create(sharedReport: CreateSharedReportApiModel): Observable<number> {
        return this.neptuneApi.api<number>(
            '/shared-reports',
            sharedReport,
            HttpVerbsEnum.POST,
            {},
            null,
            null,
            'v2'
        );
    }
    /**
     * Creates a new shared report
     */
    public send(id: number, model: SendSharedReportApiModel): Observable<void> {
        return this.neptuneApi.api<void>(
            `/shared-reports/${id}/send`,
            model,
            HttpVerbsEnum.POST,
            {},
            null,
            null,
            'v2'
        );
    }

    /**
     * Deletes the shared report specified by the ID
     */
    public delete(id: number): Observable<void> {
        return this.neptuneApi.api<void>(
            `/shared-reports/${id}`,
            undefined,
            HttpVerbsEnum.DELETE,
            {},
            null,
            null,
            'v2'
        );
    }
}
